import React, { useState } from 'react';
import InputSelect from '../../../select/InputSelect';
import InputLogin from '../../../inputs/InputLogin';
import SelectDocument from '../../../select/selectDocument';
import SelectPhone from '../../../select/selectPhone'
import { motion } from 'framer-motion';
import { FormatMontoPSE, formatPhoneNumber, handlePhoneInputChange, handleEmailChange } from '../../../../utils/Utils'
import ModalAlert from '../../../modal/ModalAlert';
import LoadingSpinner from '../../../spinners/LoadingSpinner';
import { ReactComponent as Check } from '../../../../assets/IconsColurs/IconsGeneral/checkFilled.svg'

import InputAmount from '../../../inputs/InputAmount'

const DepositarPSE = ({
    isVisible,
    montoPSE,
    setBack,
    listBanck,
    setCorreo,
    correo,
    setDocument,
    listDocument,
    numDocument,
    setNumDocument,
    setCountry,
    listCountry,
    phone,
    setPhone,
    modalVariants,
    montoCompra,
    ivaCompra,
    totalCompra,
    montoPSError,
    correoError,
    phoneError,
    numDocumentError,
    setMontoPSE,
    setCorreoError,
    setCorreoValid,
    BankList,
    FinishTransfertPSE,
    alertFinistTransfert,
    errorMessagePSE,
    banckErroPSE,
    loadingResumenPSE,
    comisionCompra

}) => {







    return (
        <>
            <div className="w-full h-full mt-5 flex flex-col gap-3">
                {alertFinistTransfert && <ModalAlert title='Transferencia exitosa' description='En pocos minutos tus COP se verán reflejados en tu billetera' className={`text-start`} labelButtonWhite='Perfecto' icon={Check} onClick={FinishTransfertPSE} />}
                <InputAmount currency={'COP'} value={montoPSE} onChange={(e) => setMontoPSE(e)} error={montoPSError} />
                <div className='w-full h-auto flex flex-col gap-3 mt-6  '>
                    <div className='w-full h-auto flex flex-row justify-between ' >
                        <p className='text-base font-medium traking-[-0.32px] leading-5 ' >
                            Banco
                        </p>
                        <div className='w-[65%]'>
                            <InputSelect setSelectOpcion={setBack} list={BankList} error={banckErroPSE} />
                        </div>
                    </div>
                </div>
                <div className='w-full h-auto flex flex-col gap-3   '>
                    <div className='w-full h-auto flex flex-row justify-between ' >
                        <p className='text-base font-medium traking-[-0.32px] leading-5 ' >
                            Correo
                        </p>
                        <div className='w-[65%] flex flex-row gap-1'  >
                            <InputLogin
                                placeholder="ejemplo@correo.com"
                                value={correo}
                                onChange={(e) => handleEmailChange(e, setCorreo, setCorreoValid)}
                                error={correoError}
                            />
                        </div>
                    </div>
                </div>
                <div className='w-full h-auto flex flex-col gap-3  '>
                    <div className='w-full h-auto flex flex-row justify-between ' >
                        <p className='text-base font-medium traking-[-0.32px] leading-5 ' >
                            Documento
                        </p>
                        <div className='w-[65%] flex flex-row gap-1'  >
                            <SelectDocument setValue={setDocument} list={listDocument} error={numDocumentError} />
                            <InputLogin placeholder='1234567890' value={numDocument} numericOnly={true} onChange={(e) => setNumDocument(e)} error={numDocumentError} />
                        </div>
                    </div>
                </div>
                <div className='w-full h-auto flex flex-col gap-3  '>
                    <div className='w-full h-auto flex flex-row justify-between ' >
                        <p className='text-base font-medium traking-[-0.32px] leading-5 ' >
                            Número teléfono
                        </p>
                        <div className='w-[65%] flex flex-row gap-1'  >
                            <SelectPhone setValue={setCountry} list={listCountry} error={phoneError} />
                            <InputLogin
                                placeholder='Número teléfono'
                                value={phone}
                                onChange={(e) => handlePhoneInputChange(e, setPhone)}
                                error={phoneError}
                                numericOnly={true}
                                formatValue={formatPhoneNumber}
                            />
                        </div>
                    </div>
                </div>
                <div className='w-full h-auto flex flex-col gap-3  '>
                    <div className='w-full h-auto flex flex-row justify-between ' >
                        <p className='text-base font-medium traking-[-0.32px] leading-5 ' >

                        </p>
                        <div className='w-[65%] flex flex-row gap-1'  >
                            <p className='text-[14px] text-center text-[#e4847f]'>{errorMessagePSE}</p>
                        </div>
                    </div>
                </div>
                {loadingResumenPSE && <LoadingSpinner />}
                {isVisible && !loadingResumenPSE && (
                    <motion.div
                        className="bg-[#26262D]"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <div
                            className={`transition-all duration-900 ease-in-out ${isVisible ? 'opacity-100 translateY-0' : 'opacity-0 translateY-5'}`}
                        >
                            <p className="text-base text-[#8A8A8E] flex font-semibold tracking-tight leading-5 mb-2">Resumen</p>
                            <div className='w-full h-auto bg-[#2B2B33] rounded-lg p-5'>
                                <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>Monto a comprar</p>
                                    <p className='text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(montoCompra)}</p>
                                </div>
                                <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>Comisión compra</p>
                                    <p className='text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(comisionCompra)}</p>
                                </div>
                                <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>IVA comisión compra</p>
                                    <p className='text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(ivaCompra)}</p>
                                </div>

                                <div className="w-full border-t border-dashed border-[#8A8A8E] my-2"></div>

                                <div className='w-full justify-between flex flex-row py-2'>
                                    <p className='text-[14px] font-normal tracking-[-0.14px] leading-[18.2px] text-[#8A8A8E]'>Total a pagar</p>
                                    <p className='text-[16px] font-bold tracking-[-0.14px] leading-[18.2px] text-[#ffffff]'>{FormatMontoPSE(totalCompra)}</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>)}
            </div>
        </>
    );
};

export default DepositarPSE;
